<div class="layout-container h-full">
  <vi-toolbar color="viorange" class="h-[64px] max-w-full">
    <button
      left
      *ngIf="codeScannerService.isMoreCamerasAvailable$ | async"
      mat-icon-button
      gtm="onCameraSwitch"
      (click)="codeScannerService.switchCamera()"
      [disabled]="!(codeScannerService.isCameraReady$ | async)"
    >
      <mat-icon>flip_camera_ios</mat-icon>
    </button>
  </vi-toolbar>

  <mat-card-content class="grow">
    <div class="video-wrapper">
      <video #video muted playsinline></video>
    </div>
  </mat-card-content>

  <mat-card-actions class="!flex flex-row flex-1 grow-0">
    <div
      class="flex flex-row justify-end items-center w-full min-w-full h-full min-h-full gap-[10px]"
    >
      <button
        mat-button
        color="primary"
        gtm="onBackDialog"
        gtmCategory="codeScanner"
        (click)="onBackClick()"
      >
        {{ 'GENERAL.BUTTON.BACK' | translate }}
      </button>
      <button
        mat-raised-button
        color="primary"
        gtm="onOpen"
        gtmAction="Manual QR code input dialog"
        gtmCategory="codeScanner"
        (click)="onManualInputClick()"
      >
        {{ '+COMMISSIONING.BUTTON.MANUAL_INPUT' | translate }}
      </button>
    </div>
  </mat-card-actions>
</div>
